import { useDecision } from '@optimizely/react-sdk';

type OptimizelyVariables = {
  max_rooms_cutoff?: number;
};

type Result = {
  isReady: boolean;
  showMessage?: boolean;
} & OptimizelyVariables;

const useAvailableRoomsMessage = (): Result => {
  const [decision, isReady] = useDecision('qantas-hotels-available-rooms-message', {
    autoUpdate: true,
  });

  const variables: OptimizelyVariables =
    decision.variables && typeof decision.variables === 'object' ? (decision.variables as OptimizelyVariables) : {};

  return {
    isReady,
    max_rooms_cutoff: variables.max_rooms_cutoff,
    showMessage: decision.enabled && decision.variationKey === 'available_rooms_variation_b_-_show_message',
  };
};

export default useAvailableRoomsMessage;
